// Shared by the public personality pages, the per-personality resources page and the
// side panel. Colors match the rest of the site (ResultsReady, PersonalityTab).

export const PERSONALITY_TYPES = [
  "Dream Chaser",
  "Wealth Architect",
  "Safety Seeker",
  "Generous Altruist",
  "Freedom Finder",
] as const;

export const PERSONALITY_COLORS: Record<string, string> = {
  "Dream Chaser": "#00A4EF",
  "Wealth Architect": "#00B3C2",
  "Safety Seeker": "#076652",
  "Generous Altruist": "#9933FF",
  "Freedom Finder": "#FF00FF",
};

export function toSlug(name: string): string {
  return name.toLowerCase().replace(/\s+/g, "");
}

export function fromSlug(slug: string): string | null {
  const normalized = slug.toLowerCase().replace(/[^a-z0-9]/g, "");
  return (
    PERSONALITY_TYPES.find(
      (t) => t.toLowerCase().replace(/[^a-z0-9]/g, "") === normalized
    ) ?? null
  );
}

// McKayla's photo sets, one folder per personality under public/images/personalities.
// Dream Chaser arrived 2026-10-12 (cropped from her 10-photo collage); the other four
// follow once she has them. A personality with no entry simply shows no photos.
export const PERSONALITY_PHOTOS: Record<string, string[]> = {
  "Dream Chaser": Array.from(
    { length: 10 },
    (_, i) => `/images/personalities/dreamchaser/${String(i + 1).padStart(2, "0")}.jpg`
  ),
};
